import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import c1 from '../../assets/Felfl group1.jpeg';
import c2 from '../../assets/Ourclient2.jpeg';
import c3 from '../../assets/Ourclient3.jpeg';
import c4 from '../../assets/Ourclient4.jpg';
import c5 from '../../assets/Ourclient5.webp';
import c6 from '../../assets/Ourclient6.webp';
import './OurClients.css';

export function OurClients() {
    const { language } = useLanguage();
    const isRtl = language === 'ar';

    const clients = [
        { img: c1 }, { img: c2 }, { img: c3 },
        { img: c4 }, { img: c5 }, { img: c6 }
    ];

    return (
        <section className={`luxury-gallery-section ${isRtl ? 'rtl' : 'ltr'}`}>
            <div className="gallery-header">
                <span className="gold-sub">{isRtl ? 'شركاء النجاح' : 'SUCCESS PARTNERS'}</span>
                <h2 className="luxury-title">{isRtl ? 'عملائنا الكرام' : 'Our Valued Clients'}</h2>
                <div className="gold-separator"></div>
            </div>

            <div className="gallery-marquee">
                <div className="gallery-track">
                    {[...clients, ...clients, ...clients].map((client, index) => (
                        <div key={index} className="logo-frame">
                            <img src={client.img} alt="Client Logo" className="logo-img-controlled" />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
